// DS: CO0.1M
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Sticky from '@wix/da-ds/pkg/Sticky';
import MobileSubmissionDetailsHeader from '../../../SubmissionDetails/MobileSubmissionDetailsHeader';
import SiteHeader from '../../../SiteHeader';
import { useDuperbrowseViewType } from '../../../Duperbrowse/DuperbrowseViewContext';

export interface Props {}

const DeviationPageHeader: React.FC<Props> = () => {
  const isMobile = useContext(MobileContext);
  const { isInDuperbrowse } = useDuperbrowseViewType();

  if (!isMobile) {
    return <SiteHeader />;
  }

  if (isInDuperbrowse) {
    return (
      <Sticky marginTop={-1}>
        {isStuck => (
          <MobileSubmissionDetailsHeader isSticky={true} isStuck={isStuck} />
        )}
      </Sticky>
    );
  }

  return (
    <>
      <SiteHeader />
      <MobileSubmissionDetailsHeader isSticky={false} />
    </>
  );
};
DeviationPageHeader.displayName = 'DeviationPageHeader';

export default DeviationPageHeader;
